import React, { useContext, useState } from 'react';
import { useCookies } from 'react-cookie';
import { Route, Switch } from 'react-router-dom';
import './styles/storelocator.css';
import './styles/localpage.css';
import LocalPage from './views/LocalPage/LocalPage';
import StoreLocator from './views/StoreLocator/StoreLocator';
import Chrome from './ui/chrome/Chrome';

import StateContext from 'common/contexts/state-context';
import MapContext from 'common/contexts/map-context';
import MapService from 'common/services/Map';
import TrackingService from 'common/services/Tracking/Tracking';
import AntiCorruptionService from 'common/services/AntiCorruption';
import FacebookPixel from 'common/components/Tracking/FacebookPIxel/FacebookPixel';

const App = ({ props }) => {
  /// CORE OF REACT STORELOC APP DONT REMOVE IT ////
  const marshalledState = AntiCorruptionService.marshallState(props);
  const [state, setState] = useState(marshalledState);
  const [cookies] = useCookies();
  TrackingService.init(state, cookies);
  MapService.initMap(state);
  const [map, setMap] = useState(MapService.initialContext);
  useContext(MapContext);
  useContext(StateContext);
  /////////////////////////////////////////////////

  return (
    <StateContext.Provider value={[state, setState]}>
      <MapContext.Provider value={[map, setMap]}>
        <FacebookPixel hardcodedKey={state.brand.segment.facebookPixel} />
        <Chrome>
          <Switch>
            <Route exact path={['/', '/location/:slug']}>
              <StoreLocator />
            </Route>
            <Route path="/:storeId">
              <LocalPage />
            </Route>
          </Switch>
        </Chrome>
      </MapContext.Provider>
    </StateContext.Provider>
  );
};

export default App;
